import React from "react"
import { useSelector } from "react-redux"

import { VIEW, EDIT, YES, ACTIVE } from "const"
import {
    StoreType,
    moduleIds,
} from "client/store"
import { markovModelsRoute } from "client/parts/routes"
import { Switch, Route } from "client/components"

import AccessDenied from "client/parts/accessDenied"

import List from "./list"
import View from "./view"
import Edit from "./edit"

const MarkovModel = () => {
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const userData = useSelector((state: StoreType) => state.system.userData)

    const { markovModuleAccess } = packageSettings
    const moduleAccess = markovModuleAccess === YES && moduleList[moduleIds.markov].status === ACTIVE
    const access = userData.accountId === 1 || moduleAccess

    if (!access) return <AccessDenied />
    return (
        <Switch>
            <Route
                path={`${markovModelsRoute}/${VIEW}/:modelId`}
                component={View}
            />
            <Route
                path={`${markovModelsRoute}/${EDIT}/:modelId`}
                component={Edit}
            />
            <Route
                path={markovModelsRoute}
                component={List}
            />
        </Switch>
    )
}
export default MarkovModel
